const Contact = () => {
  return (
    <section id="contact" className="py-24 bg-brand-dark text-white text-center relative overflow-hidden scroll-mt-20">
      <div
        className="absolute inset-0 opacity-20"
        style={{
          backgroundImage: 'radial-gradient(#4b5563 1px, transparent 1px)',
          backgroundSize: '20px 20px',
        }}
      ></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <h2 className="text-4xl md:text-5xl font-bold mb-8">Let's keep it simple.</h2>
        <p className="text-xl text-gray-400 mb-12">
          Is there a contact form? No. We prefer to keep it simple. Drop us an email, and we'll take
          it from there.
        </p>

        <a
          href="mailto:hello@thesimpleintel.com"
          className="inline-block group transition-all duration-300 transform hover:scale-105"
        >
          <span className="text-3xl md:text-5xl md:text-6xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-white pb-2 border-b-2 border-transparent group-hover:border-blue-500 transition-all">
            hello@thesimpleintel.com
          </span>
          <div className="mt-4 text-blue-400 group-hover:text-white transition-colors">
            <i className="fa-solid fa-arrow-right-long text-2xl"></i>
          </div>
        </a>
      </div>
    </section>
  )
}

export default Contact
